import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Alert, Intent } from '@blueprintjs/core';
import Toast from 'helpers/toaster';
import ServiceTypeCategory from 'components/ServiceTypeCategory/ServiceTypeCategory';
import * as DataList from 'components/DataList';

// Layout shared by the list and its loading skeleton (pages/service_type_category/index.js).
export const SERVICE_TYPE_CATEGORY_COLUMNS = [
  { area: 'name', label: 'Name', width: 'minmax(200px, 1fr)', bone: 'single' },
  { area: 'actions', label: '', width: '72px', bone: 'none' },
];

export const SERVICE_TYPE_CATEGORY_CARDS = {
  columns: 'minmax(0, 1fr) auto',
  areas: ['name actions'],
};

export const SERVICE_TYPE_CATEGORY_MIN_TABLE_WIDTH = 360;

// Categories have no show page (edit is a dialog) and no search bar.
@inject('store', 'serviceTypeCategoryStore') @observer
class ServiceTypeCategoryTable extends Component {

  @observable isDeleteDialogVisible = false;
  @observable isCategoryDialogVisible = false;
  @observable category;

  handleCategoryClick(event, serviceTypeCategory) {
    switch (event.label) {
      case 'Edit':
        this.category = serviceTypeCategory;
        this.props.serviceTypeCategoryStore.serviceTypeCategory.object = serviceTypeCategory.attributes;
        this.isCategoryDialogVisible = true;
        break;
      case 'Delete':
        this.isDeleteDialogVisible = true;
        this.category = serviceTypeCategory;
        break;
      default:
    }
  }

  handleDeleteCancel() {
    this.isDeleteDialogVisible = false;
  }

  handleDeleteConfirm() {
    this.isDeleteDialogVisible = false;
    this.props.serviceTypeCategoryStore.delete(this.category)
      .then(this.onSuccessfulDeleteCategory.bind(this))
      .catch(this.onFailedCategoryDelete.bind(this))
  }

  onSuccessfulDeleteCategory(response) {
    Toast.show({ icon: 'thumbs-up', message: 'Service type category deleted successfully!', intent: Intent.SUCCESS })
    this.category = null;
    this.isDeleteDialogVisible = false;
  }

  onFailedCategoryDelete(error) {
    this.isDeleteDialogVisible = false;
    Toast.show({ icon: 'warning-sign', message: 'Unable to delete service type category!', intent: Intent.DANGER })
  }

  onCloseCategoryDialog() {
    this.isCategoryDialogVisible = false;
  }

  onSucessCreateCategory() {
    this.isCategoryDialogVisible = false;
  }

  render() {
    let {
      onAdd,
      serviceTypeCategoryStore: {
        serviceTypeCategorySearch,
        serviceTypeCategories: {
          objects
        }
      }
    } = this.props;
    if (objects.length === 0) {
      return (
        <DataList.Empty
          noun="service type categories"
          extraAction={onAdd && { label: 'Add category', icon: 'plus', onClick: onAdd, primary: true }}
        />
      );
    }
    return(
      <React.Fragment>
        <DataList.List
          columns={SERVICE_TYPE_CATEGORY_COLUMNS}
          cards={SERVICE_TYPE_CATEGORY_CARDS}
          minTableWidth={SERVICE_TYPE_CATEGORY_MIN_TABLE_WIDTH}
          total={objects.length}
          noun="service type categories"
          note={DataList.sortNote(serviceTypeCategorySearch.order)}
        >
          {objects.map((serviceTypeCategory) => {
            const attributes = serviceTypeCategory.attributes;
            return (
              <DataList.Row key={serviceTypeCategory.id}>
                <DataList.Cell area="name">
                  <DataList.Lines primary={attributes.name} />
                </DataList.Cell>
                <DataList.Cell area="actions">
                  <DataList.Actions
                    items={[
                      { icon: 'edit', label: 'Edit category', onClick: () => this.handleCategoryClick({ label: 'Edit' }, serviceTypeCategory) },
                      { icon: 'trash', label: 'Delete category', intent: 'danger', onClick: () => this.handleCategoryClick({ label: 'Delete' }, serviceTypeCategory) },
                    ]}
                  />
                </DataList.Cell>
              </DataList.Row>
            );
          })}
        </DataList.List>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Delete"
          icon="trash"
          intent={Intent.DANGER}
          isOpen={this.isDeleteDialogVisible}
          onCancel={this.handleDeleteCancel.bind(this)}
          onConfirm={this.handleDeleteConfirm.bind(this)}
        >
          <p>
            Are you sure you want to do this?
          </p>
        </Alert>
        <ServiceTypeCategory 
          isOpen={this.isCategoryDialogVisible} 
          title={"Update Service Type Category"}
          edit={true}
          onClose={this.onCloseCategoryDialog.bind(this)}
          onSuccess={this.onSucessCreateCategory.bind(this)}
        />
      </React.Fragment>
    )
  }

};

export default ServiceTypeCategoryTable;
